"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Breadcrumbs.default;
  }
});

var _Breadcrumbs = _interopRequireDefault(require("./Breadcrumbs"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Breadcrumbs/index.js
// module id = 645
// module chunks = 0